import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { useLang } from "../context/LanguageContext";

const T = {
  ro: {
    text: "Folosim exclusiv stocare esențială în browserul tău (preferința de limbă). Nu folosim cookie-uri de analiză sau marketing.",
    btn: "De acord",
    more: "Politica de cookies",
  },
  en: {
    text: "We use only essential browser storage (your language preference). No analytics or marketing cookies.",
    btn: "Got it",
    more: "Cookie policy",
  },
};

export default function CookieConsent() {
  const { lang } = useLang();
  const [show, setShow] = useState(false);

  useEffect(() => {
    let seen = true;
    try {
      seen = !!localStorage.getItem("eman-cookie-consent");
    } catch {
      seen = true;
    }
    setShow(!seen);
  }, []);

  const accept = () => {
    try {
      localStorage.setItem("eman-cookie-consent", "essential");
    } catch {}
    setShow(false);
  };

  const t = T[lang];

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-0 inset-x-0 z-[60] p-4"
          data-testid="cookie-banner"
        >
          <div className="glass rounded-lg max-w-4xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-start sm:items-center gap-4 shadow-[0_8px_40px_rgba(0,0,0,0.6)]">
            <p className="text-sm text-slate-300 flex-1 leading-relaxed">
              {t.text}{" "}
              <Link to="/cookies" data-testid="cookie-policy-link" className="text-sovereign underline underline-offset-4 whitespace-nowrap">
                {t.more}
              </Link>
            </p>
            <button
              onClick={accept}
              data-testid="cookie-accept-button"
              className="shrink-0 bg-sovereign text-obsidian font-semibold px-6 py-2.5 text-xs tracking-[0.15em] uppercase hover:shadow-[0_0_25px_rgba(0,240,255,0.35)] transition-shadow duration-300"
            >
              {t.btn}
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
